export const pdfName = (pdf: string) => {
    const firstDashIndex = pdf.indexOf("-");
    return pdf.slice(firstDashIndex + 1);
};
